/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { ReactNode } from 'react';

// Declaring props types for DataTableHeadCell
interface Props {
  width?: string | number;
  children: ReactNode;
  align?: 'left' | 'right' | 'center';
}

const alignClass = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
} as const;

function DataTableHeadCell({
  width = 'auto',
  children,
  align = 'left',
}: Props) {
  const style: React.CSSProperties = width !== 'auto' ? { width } : {};

  return (
    <th className="py-3 px-3 border-b border-stone-200" style={style}>
      <div
        className={[
          'relative text-xxs font-bold uppercase whitespace-nowrap opacity-70 text-stone-600',
          alignClass[align],
        ].join(' ')}
      >
        {children}
      </div>
    </th>
  );
}

export default DataTableHeadCell;
